// React
import React from 'react'

// Components
import { Controls, Image, Info, Lines, Price } from './styles'
import Skeleton from 'ui/blocks/Skeleton'

const LinesSkeleton = () => {
  return (
    <Lines>
      <Image>
        <Skeleton width={60} height={60} modifiers="border-radius-md" />
      </Image>
      <Info>
        <Skeleton height={24} modifiers="display-flex width-100 margin-bottom-xs" noCenter />
        <Skeleton height={24} modifiers="width-75" noCenter />
      </Info>
      <Controls />
      <Price>
        <Skeleton height={18} modifiers="width-50" />
      </Price>
    </Lines>
  )
}

export default LinesSkeleton
